define('BrandsPage.List.Model', [
    'SCModel',
    'Utils'
], function BrandsPageListModel(
    SCModelComponent,
    Utils
) {
    'use strict';

    var SCModel = SCModelComponent.SCModel;

    function BrandsPageListModel (model, options) {
        SCModel.call(this,model,options);

        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "Modules/BrandPage/SuiteScript2/BrandsPage.List.Service.ss"
                ), true
            )
        }
    }

    BrandsPageListModel.prototype = Object.create(SCModel.prototype);

    BrandsPageListModel.prototype.constructor = BrandsPageListModel;

    // Return the AMD constructor.
    return BrandsPageListModel;
});
